import { map } from 'rxjs/operators';
import { CoreResponse } from '@models/app/response/CoreResponse';

export const mapRes = map((r) => new CoreResponse(r));
